module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chtit1"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("A C"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("APSULE")]), _vm._v(" H"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("ISTORY OF THE 13TH")]), _vm._v(" I"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("NDEPENDENT")]), _vm._v(" B"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("ATTERY")]), _vm._v(", M"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("ASSACHUSETTS")]), _vm._v(" L"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("IGHT")]), _vm._v(" A"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("RTILLERY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("T"), _c('span', {
    staticClass: "chsmallb"
  }, [_vm._v("HE 13TH")])]), _vm._v(" Independent Battery served in the Civil War from late 1862 until end of the conflict. It had a complement of 355 men during the duration of the war. Light artillery commands like this battery were mobile and served in the field alongside infantry and cavalry, as opposed to heavy artillery units, which were stationed in fixed fortifications."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 13th battery was raised by Timothy W. Terry and rendezvoused at Camp Meigs in Boston on October 27, 1862. It was under Capt. Charles H. J. Hamlin when it set out by sea for New Orleans on January 20, 1863. After short stormy voyage, during which many of the battery’s horses were killed, the ship put in at Fortress Monroe at the tip of the"), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v(" Virginia Peninsula. The men and animals spent the next six weeks there recuperating. The artillery outfit finally reached New Orleans on May 10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the summer of 1863, the battery turned its horses over to another command and shipped north with the rest of Maj. Gen. Nathaniel Banks’ XIX Corps (Department of the Gulf) to besiege the 7,500 Confederate defenders of Port Hudson, a strong bastion on the Mississippi River below Vicksburg. The men of the 13th Independent Battery served four stationary mortars and bombarded the enemy for 31 days straight. The grueling siege lasted 48 days and was the longest in American history. The Southern strongpoint finally surrendered on July 9. Wounds and disease had reduced the 13th to about 50 men, or roughly one-third of its normal strength.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following a period of rest, the 13th merged briefly with the 2nd Independent Battery, Massachusetts Light Artillery, and took part in Second Bayou Teche expedition in western Louisiana in September and October of 1863 before wintering in New Iberia and Franklin. In March of 1864, the artillerists of the 13th Independent Battery were attached to Battery L, 1st U.S. Artillery, and participated in the General Banks’ disastrous Red River Campaign. The objective was to move up the Red River, capture Shreveport, and destroy Confederate forces operating in the region and confiscate Southern cotton. The low water in the Red River stranded the Union fleet and Banks was routed at Mansfield on April 8, though he managed to blunt Confederate attacks the next day at Pleasant Hill. Banks had little choice but to retreat to Alexandria to save his command. The 13th Battery saw combat during the campaign at Pleasant Hill on April 9, at the Cane River Crossing on April 19, and again at Marksville Plains on May 13.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was during this period of the war that W. F. Oscar Federhen was recruited to the battery as a replacement. He was on his way to join the 13th, which was camped at"), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v(" Alexandria, when he was taken prisoner on May 3. Federhen never saw combat with the 13th Independent Battery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The artillery unit returned to New Orleans on June 29 and remained there for the duration of the war. After escaping from a Confederate prison camp in Texas, Federhen rejoined the unit during its final days of service. Once the war ended, Oscar and the rest of the battery returned to Massachusetts and were mustered out on July 28, 1865. During the war, the 13th battery lost one man killed in action and 27 to disease."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "notet"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(" Information about the 13th Massachusetts Light Artillery is compiled from the following sources: James L. Bowen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts in the War, 1861–1865")]), _vm._v(" (Springfield, Mass: Clark W. Bryan & Co., 1889); Massachusetts Adjutant General’s Office, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts Soldiers, Sailors, and Marines in the Civil War")]), _vm._v(" (Norwood, Mass.: Norwood Press, 1931); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Annual Report of the Adjust-ant-General, of the Commonwealth of Massachusetts, with reports from the Quartermaster-General, Surgeon- General, and Master of Ordnance")]), _vm._v(" (Boston: Wright & Potter), for the years 1863, 1864, and 1865.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(" For additional detailed information on the 13th Independent Battery than the sources earlier cited, see Frederick H. Dyer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Compendium of the War of the Rebellion")]), _vm._v(" (Morningside: Dayton, OH: 1978), 25, 157, 550, 551, 553, 556, 1247.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-579e1e52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_A_Capsule_History.vue
// module id = 90
// module chunks = 0